import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    items: [
      { label: '首页', path: '/' },
      { label: '交友技巧', path: '/category/dating-tips' },
      { label: '生活分享', path: '/category/life-share' },
      { label: '社区活动', path: '/category/community-events' },
    ],
  },
  {
    title: '更多内容',
    items: [
      { label: '自我成长', path: '/category/self-growth' },
      { label: '健康养生', path: '/category/health-wellness' },
      { label: '文化娱乐', path: '/category/culture-entertainment' },
    ],
  },
  {
    title: '关于我们',
    items: [
      { label: '品牌介绍', path: '/about' },
      { label: '口碑评价', path: '/about#reputation' },
      { label: '联系我们', path: '/about#contact' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-foreground-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-heart-line text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-bold text-background-50 font-heading">男同网</span>
            </Link>
            <p className="text-sm leading-relaxed text-foreground-400">
              专为男同群体打造的社群交友平台。安全、私密、友好，在这里找到属于你的社群归属感。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">{group.title}</h4>
              <ul className="space-y-3">
                {group.items.map((item) => (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 男同网 版权所有。致力于为男同社群提供安全友好的交友平台。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">社区规范</a>
          </div>
        </div>
      </div>
    </footer>
  );
}